import { useMemo } from "react";
import { DetailedTableInfoDc } from "@evergis/api";

import { table } from "../../resources/tables";
import { getTableInfo } from "../../evergis/core/table/getTableInfo";

export const useTable = (tableName: string, waitInput?: boolean) => {
  const { data, loading, error, refetch } = table.use({ input: tableName, waitInput });

  return useMemo(
    () => ({
      table: getTableInfo(data as DetailedTableInfoDc),
      loading,
      error,
      refetch,
    }),
    [data, loading, error, refetch],
  );
};
